<div class="container main" *ngIf="!isAnyError && isSupported && isDataAvailable">

  <!-- Tab Navigation -->
  <div class="container-fluid mb-5 padding-0">
    <div class="inbox-container">
      <div class="ltms-tabs lato-bold-dark">

        <div class="ltms-tab" [ngClass]="{ 'ltms-active-tab': activeTab === 'overview' }"
          (click)="toggleTab('overview')">Overview</div>
        <!-- <div class="ltms-tab" [ngClass]="{ 'ltms-active-tab': activeTab === 'profile' }" (click)="toggleTab('profile')">
          Profile</div> -->
        <div class="ltms-tab" [ngClass]="{ 'ltms-active-tab': activeTab === 'timeline' }"
          (click)="toggleTab('timeline')">Timeline</div>
      </div>
      <!-- Tab Content -->
      <div>
        <div *ngIf="activeTab === 'overview'">
          <div class="row">
            <p class="overview-text">Understand Individual Relationships! The Relationship View is your single source of
              truth for each
              customer’s unified view, tracing their lifetime journey from first contact to their latest interaction.
              Track NPS, explore feedback history, and pinpoint pivotal moments to discover crucial connections for
              personalized engagement. Understand how they evolve and build stronger, lasting loyalty.</p>
          </div>
          <!-- <app-project-inbox-sent> -->
            <div class="row">
              <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                <div class="nps-bottom-container response-card" [ngClass]="getNpsClass(NPSscore)">
                  <div class="interation-details-container">
                    <span class="intration-title">Customer NPS</span>
                    <div class="nps-score">
                      <div class="nps-number">{{ NPSscore }}</div>
                    </div>
                    <div class="nps-score-description">
                      Track each customer’s real-time NPS - their lifetime contribution to brand NPS. A new metric to
                      measure loyalty, understand the unified customer journey, and improve the experience.
                    </div>
                  </div>
                </div>
                <div class="sentiment-bottom-container response-card">
                  <div class="interation-details-container">
                    <span class="intration-title">Sentiment Breakdown</span>
                    <p class="doughnut-text">Quickly understand sentiment! See promoters, passives, detractors, and the
                      total responses given by a customer.</p>
                      <img class="first-douhnut media-first" src="assets/images/happy.svg">
                      <img class="second-douhnut" src="assets/images/sad.svg">
                      <img class="thirt-douhnut" src="assets/images/upset.svg">
                      <app-doughnut-view [values]="doughnutData" class="custom-chart">
                        <div class="doughnut-responn">
                          <canvas id="myChart" class="doughnut-canvas"></canvas>
                      </div>
                      </app-doughnut-view>
                  </div>
                </div>
                <div class="left-bottom-container response-card">
                  <div class="interation-details-container">
                    <span class="intration-title">Interaction dates</span>
                    <div class="first-intraction-details text-first"><span class="interaction-txt">First interaction</span> &nbsp;&nbsp; <span
                        class="date-text">{{firstRecevied}}</span></div>
                    <div class="last-intraction-details text-first"><span class="interaction-txt">Last interaction</span> &nbsp;&nbsp; <span
                        class="date-text">{{lastRecevied || firstRecevied}}</span></div>
                  </div>
                </div>
              </div>
              <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                <div class="rating-trend">
                  <div class="chart">
                    <h3 class="chart-title">Lifetime Loyalty</h3>
                    <p class="chart-sub-title">See a customer's satisfaction evolve! Visualize their journey, pinpoint
                      important interactions and impact points</p>
                      <h3 class="chart-title-count">{{ doughnutData.chartData.total }}</h3>
                    <p class="chart-sub-title">Lifetime Responses</p>
                    <div class="chart-container">
                      <app-score-line-chart class="line-card" [chartPlugins]="lineChartPlugins"
                        [chartData]="lineChartData"></app-score-line-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row table-Head">
              <span class="table-title">Lifetime Response Details: </span>
              <p class="Lifetime-Response-text">Access detailed feedback! See ratings, comments, interaction dates, and response times all in one
                place.
              </p>
              <app-ltms-data-table-v2 class="ltms-history-table-container" [columns]="columns" [data]="tableDataList"
                [errorCode]="errorCode" >
              </app-ltms-data-table-v2>
            </div>
          <!-- </app-project-inbox-sent> -->
        </div>
        <div *ngIf="activeTab === 'profile'">
          <!-- <app-project-inbox-sent> -->
            <div class="card">
              <div class="card-header-new">
                <div class="avatar">
                </div>
                <div class="field">
                  <span class="profile-txt">Profile:</span>
                  <img class="profile-img" src="assets/images/account-circle.svg" />
                  <span class="view-profile" *ngIf="isTSEnabled" (click)="viewProfile($event,customerId)">View
                    profile</span>
                </div>
              </div>
              <div class="details">
                <div class="field">
                  <span class="name-txt">Name:</span>
                  <span class="name-txt-right">
                    {{ isTSEnabled ? 'xxxxx-xxxxx' : name }}
                  </span>
                </div>
                <div class="field">
                  <span class="name-txt">Email:</span>
                  <span class="name-txt-right">
                    {{ isTSEnabled ? 'xxxxx-xxxxx' : emailAddress }}
                  </span>
                </div>
                <div class="field">
                  <span class="name-txt">Phone:</span>
                  <span class="name-txt-right"> {{ isTSEnabled ? 'xxxxx-xxxxx' : phoneNumber }}
                  </span>
                </div>
                <div class="field">
                  <span class="name-text">Customer Id:</span>
                  <span class="customer-text"> {{ isTSEnabled ? 'xxxxx-xxxxx' : customerId }}
                  </span>
                </div>
              </div>
            </div>
          <!-- </app-project-inbox-sent> -->
        </div>
        <div *ngIf="activeTab === 'timeline'">
          <!-- <app-project-inbox-sent> -->
            <p class="overview-text">Trace a customer’s history! View engagements, feedback, and satisfaction changes over time.</p>

            <div class="main-timeline">
              <!-- Timeline vertical line -->
              <div class="timeline-line">
              </div>
              <!-- Recent Label -->
              <div class="vertical-line">
                Recent
              </div>
              <!-- Oldest Label -->
              <div class="vertical-bottom-line">
                Oldest
              </div>
              <!-- Loop through timeline items -->
              <div *ngFor="let item of tableDataList.slice().reverse(); let i = index" class="table-data-row" [ngStyle]="{
                '--justify-content': i % 2 === 0 ? 'flex-start' : 'flex-end'
              }">
                <!-- Timeline dot -->
                <div class="timeline-dot"></div>

                <!-- Date Container -->
                <div class="responded-date" [ngClass]="{ 'left-align': i % 2 === 0, 'right-align': i % 2 !== 0 }">
                  {{ item["Responded Date"].split(':')[0] }}
                </div>
                <!-- Message Container -->
                <div class="rating-card" 
                [ngClass]="{
                  'light-red-rating': item['Primary Rating'] <= 6,
                  'light-yellow-rating': item['Primary Rating'] >= 7 && item['Primary Rating'] <= 8,
                  'light-green-rating': item['Primary Rating'] >= 9
                }" 
                [ngStyle]="{
                  'background-color': item['Primary Rating'] === 'NA' ? '#F2F3F7' : 
                  (item['Primary Rating'] >= 0 && item['Primary Rating'] <= 6 ? this.applyOpacity(this.firstColor) :
                  (item['Primary Rating'] >= 7 && item['Primary Rating'] <= 8 ? this.applyOpacity(this.secondColor) :
                  this.applyOpacity(this.thirdColor))),
                  'background-image': item['Primary Rating'] == 'NA' ? 'none' :
                                      (item['Primary Rating'] <= 6 ? 'url(assets/images/verbatim/emoticon_2.svg)' :
                                      (item['Primary Rating'] >= 7 && item['Primary Rating'] <= 8 ? 'url(assets/images/verbatim/emoticon_8.svg)' :
                                      (item['Primary Rating'] == 9 ? 'url(assets/images/verbatim/emoticon_9.svg)' : 
                                      'url(assets/images/verbatim/emoticon_10.svg)'))),
                  'background-position': 'right 15px bottom 15px',
                  'background-size': '50px auto',
                  'background-repeat': 'no-repeat',
                  'padding-bottom': '12px'
                }">
                  <!-- Rating Badge -->
                  <div class="rating-badge" [ngClass]="{
                    'badge-light-red': item['Primary Rating'] !== 'NA' && item['Primary Rating'] <= 6,
                    'badge-light-yellow': item['Primary Rating'] !== 'NA' && item['Primary Rating'] >= 7 && item['Primary Rating'] <= 8,
                    'badge-light-green': item['Primary Rating'] !== 'NA' && item['Primary Rating'] >= 10,
                    'badge-light-purple': item['Primary Rating'] === 9,
                    'badge-light-grey': item['Primary Rating'] === 'NA'

                  }" [ngStyle]="{
                    left: i % 2 !== 0 ? '13px' : '13px'
                  }">
                    {{ item["Primary Rating"] }}
                  </div>
                  <!-- <p class="rating-comment">
                    {{ item["Comments"] === 'NA' ? 'No comment provided' : item["Comments"] }}
                  </p> -->
                  <!-- Message Content -->
                  <p class="rating-comment">
                    {{ item["Comments"] ==='NA' ? 'No comment provided' : item["Comments"] }}
                  </p>
                </div>
              </div>

            </div>
          <!-- </app-project-inbox-sent> -->
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isAnyError">
  <app-ltms-error [code]="errorCode"></app-ltms-error>
</div>
<div class="loader" *ngIf="showLoader">
  <app-ltms-loader></app-ltms-loader>
</div>
<div class="feature-support" *ngIf="!isSupported && !isAnyError">
  This feature Not Supported on Account Level
</div>